import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import NavbarBottom from './NavbarBottom';

const EbookDetail = () => {

    const params = useParams();
    const [newsDetail, SetNewsDetail] = useState([]);
    const [newsList, SetNews] = useState([]);
    const urlImg = `${process.env.REACT_APP_BASEURL}/berita/`;

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/ebook-detail/${params.id}`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas);
                SetNewsDetail(datas.data[0]);
        });

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/ebook`)
        .then((res) => {
            return res.json();
        })
        .then((datas) => {
            //console.log(datas.data);
            SetNews(datas.data.data);
        });


        //console.log(newsDetail);
    }, []);
    

    return (
        <>
            <NavbarBottom />
            <div className="p-4 bg-sky-50">
                <div class="flex flex-wrap justify-between">
                    <div class="bg-white w-full md:w-8/12 px-4 mb-8 rounded"><br />
                        <img src={urlImg + '' + newsDetail.images} alt="Berita Image" class="w-full object-cover rounded" />
                        <h2 class="font-bold mt-2 mb-2" style={{ fontFamily: 'MuseoSansRounded300', fontSize: 16 }}>
                            {newsDetail.nama}
                        </h2>
                        <p class="text-gray-700 mb-4" style={{ fontSize: 14 }}>

                            <div dangerouslySetInnerHTML={{ __html: newsDetail.isi }}></div>

                        </p>

                    </div>
                    <div class="w-full md:w-4/12 px-4 mb-8">
                        <div class="bg-gray-100 px-4 py-6">
                            <h3 class="font-bold text-left" style={{ fontSize: 18 }}>
                                <span class="text-[#FF3C3C]">
                                    EBOOK LAIN
                                </span>
                            </h3>
                        </div>
                        <div class="flex flex-col divide-y dark:divide-gray-300 bg-white px-4" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 14 }}>
                            {newsList.filter((item) => item.id != params.id).map((data_news, indexnews_list) => (
                                <div class="flex px-1 py-4">
                                    <img src={urlImg + '' + data_news.images} alt="" class="flex-shrink-0 object-cover w-20 h-20 mr-4 dark:bg-gray-500" />
                                    <div class="flex flex-col flex-grow">
                                        <a rel="noopener noreferrer" href={`/detail-berita/${data_news.id}/${data_news.link}`} class="hover:underline" style={{ fontSize: 12 }}>

                                            {data_news.nama}

                                        </a>
                                        <p class="mt-auto" style={{ fontFamily: 'MuseoSansRounded400', fontSize: 10 }}>
                                            {data_news.tgl}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default EbookDetail;
